export default __webpack_public_path__ + "static/media/3in1_uk.eba71bf3.svg";